import React, { useEffect, useState } from "react";
import ImageWithFallback from "../components/ImageWithFallback";
import useIsMobile from "../hooks/useIsMobile";
import ReactPlayer from "react-player";
import { configuration } from "../helpers/config";
import { getImageDimensions } from "../utils/GenUtils";
import useWindowSize from "../hooks/useWindowSize";
import { Constants } from "../helpers/constants";

// banner component for cms pages and other pages with title , image or video.
export default function CommanContentBanner({
  classname,
  bannerSrc,
  altText,
  videoLink,
  info_popup_width,
  info_popup_height,
  vedio_info,
  bannerText,
  titleThemeData,
  banner_height, 
  PlaybuttonHeightfromBottom,
  infobuttonHeightfromBottom,
  modelHeight
}) {
  const isMobile = useIsMobile();
  const windoWidth = useWindowSize();

  const [bannerHeight, setBannerHeight] = useState(1004);
  const [mobileBannerHeight, setMobileBannerHeight] = useState(1980);

    const [isPlaying, setIsPlaying] = useState(true);
      const [showInfo, setShowInfo] = useState(false);
      
      const togglePlayPause = () => {
        setIsPlaying(!isPlaying);
      };

  useEffect(() => {
    // function to get dimensions of an image.
    getImageDimensions(`${configuration.IMG_URL}${bannerSrc}`)
      .then(({ height, width }) => {
        // if mobile, set height and accordingly
        if (isMobile) {
          if (height < 600) {
            setMobileBannerHeight(564);
          } else if (height > 600) {
            setMobileBannerHeight(1080);
          }
        } else {
          if (height < 800) {
            setBannerHeight(738);
          } else if (height > 800) {
            setBannerHeight(1004);
          }
        }
      })
      .catch((error) => {
        // console.error(error.message);
      });
  }, [bannerSrc]);
  return (
    <div
      className={`${
        classname ? classname + " container-fluid" : "container-fluid"
      } relative`}
    >
      {videoLink ? (
         <div style={{ position: "relative", width: "100%" }}
         className={isMobile ? "banner_vph_mobile" : "banner_vph_desktop"} >
                                   <ReactPlayer
          playing={isPlaying}
          url={ videoLink? `${configuration.IMG_URL}${videoLink}`: "" }
          volume={0}
          height={banner_height}
          width={"100%"}
          loop={true}
          playsinline
        />
                            
                                {/* Play/Pause Button */}
                                <button
                                  onClick={togglePlayPause}
                                  style={{
                                    position: "absolute",
                                    bottom: PlaybuttonHeightfromBottom,
                                    right: "90px",
                                    backgroundColor: "white",
                                    color: "black",
                                    border: "2px solid #001151",
                                    borderRadius: "50%", // Circular
                                    cursor: "pointer",
                                    zIndex: 1,
                                    width: "40px",
                                    height: "40px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    marginRight:"10px",
                                    boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
                                  }}
                                >
                                  <img
                                    src={
                                      isPlaying
                                        ? `${configuration.IMG_STATIC_URL}pause.svg`
                                        : `${configuration.IMG_STATIC_URL}Play.svg`
                                    }
                                    alt={isPlaying ? "Pause" : "Play"}
                                    style={{ width: "24px", height: "24px" }}
                                  />
                                </button>
                            
                                {/* Info Button */}
                                <button
                                  onClick={() => setShowInfo(true)}
                                  style={{
                                    position: "absolute",
                                    bottom: infobuttonHeightfromBottom,
                                    right: "20px",
                                    backgroundColor: "white",
                                    color: "black",
                                    border: "2px solid #001151", 
                                    
                                    cursor: "pointer",
                                    zIndex: 1,
                                    height:"36px",
                                    width:"68px",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                 <span>{Constants.allcomponents.INFO}</span>
                                </button>
                            
                                {/* Info Modal */}
                                {showInfo && (
                                  <div
                                  style={{
                                    position: "absolute",
                                    top: "40%",
                                    left: "50%",
                                    transform: "translate(-50%, -50%)",
                                    backgroundColor: "#fff",
                                    padding: "20px",
                                    // borderRadius: "10px",
                                    boxShadow: "0 0 10px rgba(0,0,0,0.3)",
                                    zIndex: 10,
                                    width: `${info_popup_width}`,
                                    height:info_popup_height,
                                    
                                  }}
                                  >
                                     <div className="flex align">
              <p style={{ fontWeight: 400, fontFamily: "SuzukiPROBold", fontSize: "24px"  }}>{Constants.allcomponents.INFO_TITLE}</p>
                <button
                  onClick={() => setShowInfo(false)}
                  style={{
                    position: "absolute",
                    top: "10px",
                    right: "15px",
                    background: "none",
                    border: "none",
                    fontSize: "24px",
                    cursor: "pointer",
                  }}
                  aria-label="Close"
                 >
               <span aria-hidden="true" role="presentation">×</span>
                </button>
                </div>
                <div  style={{
                     marginTop:"20px",
                     fontSize: "16px",
                     fontWeight: "400",
                     fontFamily: "SuzukiPROBold",
                    
                  }}>
                  <p style={{overflow:"scroll",height:modelHeight}}>{vedio_info}</p>
                </div>
                                  </div>
                                )}
                                 <div className="mp_overlay_banner light-grad"></div>
                              </div>
       
      ) : (
        <ImageWithFallback
          src={
            bannerSrc
              ?  `${configuration.IMG_URL}${bannerSrc}`
              : `${configuration.IMG_STATIC_URL}assets/images/cms-pages/notAvailable.jpg`
          }
          width={isMobile ? 768 : 1928}
          height={isMobile ? mobileBannerHeight : bannerHeight}
          alt={altText}
          fallback={`${configuration.IMG_STATIC_URL}assets/images/cms-pages/notAvailable.jpg`}
          isMobile={isMobile}
        />
      )}
      {bannerText && (
        <div className="container-fluid absolute bottom-[60px] z-[1] left-0 right-0">
          <div className="container">
            <h2
              className=" text-[30px] leading-[41px] md:text-[60px] md:leading-[62px] text-[#FFFFFF] uppercase md:max-w-[70%] lg:max-w-[50%]"
              style={{
                color: titleThemeData?.titleColor,
                fontSize:
                  windoWidth.width > 1024 ? titleThemeData?.titleFontSize : "",
              }}
            >
              {bannerText}
            </h2>
          </div>
        </div>
      )}
    </div>
  );
}
